export type RouteConfig = {
  pathTemplate: string
  element: JSX.Element
}

export type NamedRoutes = Record<string, RouteConfig>

export const routeConfigs = (...namedRoutesArray: Array<NamedRoutes>): Array<RouteConfig> => {
  return namedRoutesArray.map((namedRoutes) => Object.values(namedRoutes)).flat()
}

export const interpolatePath = (pathTemplate: string, args: Array<string | number>): string => {
  return pathTemplate.replace(/:[^/]+/g, () => args.shift()!.toString())
}
